import { tooltipClasses } from "@mui/material";
import { GridRowId } from "@mui/x-data-grid";
import { ReactElement, useMemo } from "react";
import { TbHistory, TbInfoCircle } from "react-icons/tb";

import { softColors } from "@/constants/colors";
import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";
import { PlanEditableFields, usePlanInitialVal, usePlanIsChanged } from "@/stores/use-plan-table";

function HistoryInfo<T>({
    field,
    id,
    renderHistoryComp,
}: {
    field: string;
    id: GridRowId;
    renderHistoryComp: (value: T) => ReactElement<{}>;
}) {
    const isChanged = usePlanIsChanged(id, field as keyof PlanEditableFields);
    const initialVal = usePlanInitialVal(id, field as keyof PlanEditableFields) as T;
    const tooltipInfo = useMemo(() => {
        if (!isChanged) return false;

        return {
            ...softColors.brown,
            tooltip: {
                title: "İlk Veri Değeri",
                description: String(initialVal),
                descriptionComp: renderHistoryComp(initialVal),
            },
            component: () => TbHistory,
        };
    }, [isChanged, initialVal, renderHistoryComp]);

    return (
        tooltipInfo && (
            <NoMaxWidthTooltip
                arrow
                sx={{
                    [`& .${tooltipClasses.tooltip}`]: {
                        backgroundColor: "white",
                        border: "none",
                        padding: "0px !important",
                        fontSize: 12,
                        maxWidth: "200px !important",
                    },
                }}
                title={<HotelStatusTooltip status={tooltipInfo} />}
            >
                <div className="max-w-fit absolute top-1 right-2 z-50 max-h-fit !ml-auto">
                    <TbInfoCircle />
                </div>
            </NoMaxWidthTooltip>
        )
    );
}

export default HistoryInfo;
